<template>
    <div class="index_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''" style="padding-top: 72px">
        <head-nav @userInfo="getUserToken"></head-nav>
        <div class="feedback_body" v-if="permissions == 1">
            <div id="downBox" class="zhanwei" name="downBox"></div>
            <div class="title">产品问题反馈</div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="日期">
                    <el-date-picker v-model="date" type="daterange" range-separator="至" value-format="yyyy-MM-dd"
                        start-placeholder="开始日期" end-placeholder="结束日期" @change="getTimeArr">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="用户机器码">
                    <el-input v-model="formInline.machineCode" placeholder="用户机器码"></el-input>
                </el-form-item>
                <el-form-item label="数据编号">
                    <el-input v-model.number="formInline.id" placeholder="数据编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="seachBtn">查询</el-button>
                    <el-button @click="resetForm">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="feedback_main">
                <di class="left">
                    <span>已找到数据：{{ total }}条</span>
                    <span>总大小：{{ totalsize }}</span>
                </di>
                <el-button type="primary" @click="downLoadBtn" size="small" :loading="downLoadLoading" :disabled="total<1">下载</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%" border>
                <el-table-column prop="id" label="数据编号" width="180" align="center">
                </el-table-column>
                <el-table-column prop="machineCode" label="用户机器码" width="180" align="center">
                </el-table-column>
                <el-table-column label="反馈内容" align="center">
                    <template slot-scope="scope">
                        <div v-html="scope.row.content"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="fileSize" label="附件大小" align="center">
                </el-table-column>
            </el-table>
            <el-pagination v-if="total > 10" background layout="prev, pager, next" :total="total"
                :page="formInline.pageNo" @current-change="changePage">
            </el-pagination>
        </div>
        <div class="feedback_body nopermissions" v-else>该账号无访问权限</div>
    </div>
</template>

<script>
import headNav from "@comm/components/document-conversion/headerPage";
import { getUserInfo} from "@comm/utils/auth";
import { enclosureList, downloadProblemRecord,queryDownload } from "@comm/api/document-conversion";
import { saveAs } from "file-saver";
import { getfilesize } from "@comm/utils/tools";
import common from "@comm/utils/common";
export default {
    components: { headNav },
    name: "feedbackData",
    data() {
        return {
            isPhone: false,
            formInline: {
                id: '',
                machineCode: '',
                beginTime: '',
                endTime: '',
                pageNo: 1,
                pageSize: 10
            },
            formData:{
                id: '',
                machineCode: '',
                beginTime: '',
                endTime: '',
                pageNo: 1,
                pageSize: 10
            },
            date: [],
            tableData: [],
            permissions: null,
            total: 0,
            totalsize: 0,
            code: null,
            downLoadLoading:false
        };
    },
    created() {
        document.title = "查看用户反馈数据";
        let userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
        this.code = this.$route.query.code ? this.$route.query.code : null;
        if (!this.code && !userInfo) {
            this.loginBtn()
        }else {
            this.permissions = userInfo ? userInfo.permissions : null;
            if (this.permissions) {
                this.getList()
            }
        }

    },
    mounted() {

    },
    watch: {

    },
    computed: {},
    methods: {
        loginBtn() {
            let path = this.$route.path;
            window.open(
                `https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
                "_self"
            );
        },
        getUserToken(data) {
            let userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
            this.permissions = userInfo ? userInfo.permissions : null;
            if (this.permissions) {
                this.getList()
            }
        },
        changePage(page) {
            this.formInline.pageNo = page
            this.getList()
        },
        getTimeArr(val) {
            if (val) {
                this.formInline.beginTime = val[0]
                this.formInline.endTime = val[1]
            } else {
                this.formInline.beginTime = ''
                this.formInline.endTime = ''
            }
        },
        seachBtn() {
            
            if(this.formInline.id){
                let boolean = new RegExp("^[1-9][0-9]*$").test(this.formInline.id);
				if (!boolean) {
					this.$message.error("请输入数字");
					this.formInline.id = "";
                    return
				}
            }
            this.formInline.pageNo = 1
            this.formData = {
                id: this.formInline.id,
                machineCode: this.formInline.machineCode,
                beginTime: this.formInline.beginTime,
                endTime: this.formInline.endTime,
                pageNo: 1,
                pageSize: 10
            }
            this.getList()
        },
        resetForm() {
            this.formInline = {
                id: '',
                machineCode: '',
                beginTime: '',
                endTime: '',
                pageNo: 1,
                pageSize: 10
            }
            this.formData = {
                id: '',
                machineCode: '',
                beginTime: '',
                endTime: '',
                pageNo: 1,
                pageSize: 10
            }
            this.date = []
            this.getList()
        },
        getList() {
            enclosureList(this.formInline).then((res) => {
                this.tableData = res.data.list
                this.total = res.data.total
                this.totalsize = res.data.totalsize>0?getfilesize(res.data.totalsize):0
                if (!this.tableData) { return }
                this.tableData.forEach((item) => {
                    item.fileSize = getfilesize(item.fileSize)
                })
            })
        },
        downLoadBtn(){
            this.downLoadLoading=true
            let { pageNo, pageSize, ...params } = this.formData
            queryDownload(params).then((res)=>{
                this.downLoad(params)
            }).catch((res)=>{
                this.downLoadLoading=false
                this.$message.closeAll();
                this.$message.error(res.msg)
            })
        },
        downLoad(params) {
            downloadProblemRecord(params).then((res) => {
                if (!res) {
                    this.$message.closeAll();
                    this.$message.error("下载文件失败");
                    this.downLoadLoading=false
                    return false;
                }
                let filename = res.headers["filename"];
                const blob = new Blob([res.data]);
                if (sessionStorage.getItem("browserType") == "IE") {
                    saveAs(blob, filename);
                } else {
                    const downloadElement = document.createElement("a");
                    const href = window.URL.createObjectURL(blob); // 创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = decodeURIComponent(filename);
                    // downloadElement.download = file.file.filename
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); // 点击下载
                    document.body.removeChild(downloadElement); // 下载完成移除元素
                    window.URL.revokeObjectURL(href); // 释放blob对象
                }
                this.downLoadLoading=false
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.el-pagination {
    float: right;
    margin-top: 20px;
}

.feedback_body {
    width: 1200px;
    margin: 0 auto;

    &.nopermissions {
        margin-top: 10%;
        text-align: center;
        font-size: 16px;
    }

    .title {
        margin-bottom: 32px;
    }
}

.feedback_main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .left {
        span {
            margin-right: 20px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/feedbackData.vue